var _Container, _Icon;

import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Avatar, Container, EditorUserTypeIcon, Icon, NavLink } from "../../../../../Common";
import { Heading } from "../../../../../Typography";
import { useHeaderContext } from '../../../HeaderContext';
import styles from './UserBlock.scss';

var UserBlock = function UserBlock(_ref) {
  var _Heading;

  var className = _ref.className,
      onActiveNavLinkClick = _ref.onActiveNavLinkClick,
      onClickLogin = _ref.onClickLogin;

  var _useTranslation = useTranslation(['headerUi']),
      t = _useTranslation.t;

  var _useHeaderContext = useHeaderContext(),
      user = _useHeaderContext.user;

  if (user) {
    var username = user.username,
        avatar = user.avatar,
        profileLink = user.profileLink,
        isEditor = user.isEditor;
    var userInfoMarkup = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
      size: "standard",
      userName: username,
      src: avatar,
      alt: username,
      className: styles.avatar
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.usernameWrap
    }, _Heading || (_Heading = /*#__PURE__*/React.createElement(Heading, {
      level: 3
    }, username)), isEditor && (_Container || (_Container = /*#__PURE__*/React.createElement(Container, {
      marginLeft: 1
    }, /*#__PURE__*/React.createElement(EditorUserTypeIcon, null))))));
    if (profileLink) return /*#__PURE__*/React.createElement(NavLink, {
      to: profileLink,
      className: classnames(styles.wrapper, className),
      activeClassName: classnames(styles.wrapper, styles.button, className),
      onActiveNavLinkClick: onActiveNavLinkClick
    }, userInfoMarkup);
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.wrapper, className)
    }, userInfoMarkup);
  }

  if (onClickLogin) return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClickLogin,
    className: classnames(styles.wrapper, styles.button, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.iconWrapper, styles.avatar)
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    color: "text-inverted",
    name: "man"
  }))), /*#__PURE__*/React.createElement(Heading, {
    level: 3
  }, t('LOGIN_BTN_TEXT')));
  return null;
};

export default UserBlock;